import axios from 'axios';

import {
  MultimediaDeleteRequest,
  MultimediaGetRequest,
  MultimediaGetResponse,
  MultimediaParams,
  MultimediaPatchRequest,
  MultimediaPostRequest,
  MultimediaPostResponse,
} from '../model/multimediaModel';

export const MultimediaApi = {
  post: (data: MultimediaPostRequest) => {
    const formData = new FormData();

    formData.append('file', data.file!);
    formData.append('name', data.name ? data.name : (data.file as File).name);

    return axios.post<MultimediaPostResponse>('/api/media_objects', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getOne: (params: MultimediaParams) => {
    return axios.get<MultimediaGetResponse>(`/api/media_objects/${params.id}`);
  },
  getAll: (params: MultimediaGetRequest) => {
    return axios.get<MultimediaGetResponse[]>('/api/media_objects', {
      params: params,
    });
  },
  patch: (params: MultimediaParams, data: MultimediaPatchRequest) => {
    return axios.put<MultimediaPatchRequest>(`/api/media_objects/${params.id}`, data);
  },
  delete: (params: MultimediaParams) => {
    return axios.delete<MultimediaDeleteRequest>(`/api/media_objects/${params.id}`);
  },
};
